class Controller {
  constructor() {
    "ngInject";
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/sideGrid/sideGrid.controller.js